import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Vehicle, Driver } from "../data/database";
import "./HomeView.css";

interface HomeViewProps {
    vehicles: Vehicle[];
    drivers: Driver[];
    onShowIntro?: () => void;
    onShowPricing?: () => void;
}

const HomeView: React.FC<HomeViewProps> = ({ vehicles, drivers, onShowIntro, onShowPricing }) => {
    const [isPrivacyOpen, setIsPrivacyOpen] = useState(false);
    const [isTermsOpen, setIsTermsOpen] = useState(false);

    const totalDrivers = drivers.length || 219;
    const totalVehicles = vehicles.length || 219;
    const runningVehicles = 208;
    const inspectionVehicles = 10;
    const unassignedDrivers = 11;

    const navigate = useNavigate();

    return (
        <div className="home-dashboard">
            <div className="home-header-section">
                <div className="home-header-left">
                    <div className="home-header-badge">
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="3" width="7" height="7"></rect><rect x="14" y="3" width="7" height="7"></rect><rect x="14" y="14" width="7" height="7"></rect><rect x="3" y="14" width="7" height="7"></rect></svg>
                        <span className="badge-text">DASHBOARD OVERVIEW</span>
                    </div>
                    <h1 className="home-title">핵심 상태 요약</h1>
                    <p className="home-subtitle">차량 및 운전자 상태를 한눈에 파악하고 효율적으로 관리하세요.</p>
                </div>
                <div className="home-header-right">
                    <button className="home-btn-intro main-intro" onClick={onShowIntro}>
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="16" x2="12" y2="12"></line><line x1="12" y1="8" x2="12.01" y2="8"></line></svg>
                        EView 서비스 소개
                    </button>
                </div>
            </div>

            <div className="home-section-grid">
                {/* Column 1: 관리 */}
                <div className="home-col">
                    <div className="home-section-tag">관리</div>
                    <div className="home-card-stack">
                        <div className="home-card">
                            <div className="home-card-header">
                                <div className="home-card-title">
                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="1" y="3" width="15" height="13"></rect><polygon points="16 8 20 8 23 11 23 16 16 16 16 8"></polygon><circle cx="5.5" cy="18.5" r="2.5"></circle><circle cx="18.5" cy="18.5" r="2.5"></circle></svg>
                                    <span>차량 관리</span>
                                </div>
                                <button className="home-btn-outline mint" onClick={() => navigate('/management/fleet')}>차량 등록</button>
                            </div>
                            <div className="home-card-content">
                                <div className="stat-row"><span className="stat-label">전체 법인 차량</span><span className="stat-value"><strong>{totalVehicles}</strong> 대</span></div>
                                <div className="stat-row"><span className="stat-label">현재 운행 대수</span><span className="stat-value"><strong>{runningVehicles}</strong> 대</span></div>
                                <div className="stat-row"><span className="stat-label">점검 권고 차량</span><span className="stat-value"><strong>{inspectionVehicles}</strong> 대</span></div>
                            </div>
                        </div>
                        <div className="home-card">
                            <div className="home-card-header">
                                <div className="home-card-title">
                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="9" cy="7" r="4"></circle></svg>
                                    <span>운전자 관리</span>
                                </div>
                                <button className="home-btn-outline mint" onClick={() => navigate('/management/driver')}>운전자 등록</button>
                            </div>
                            <div className="home-card-content">
                                <div className="stat-row"><span className="stat-label">전체 사용자</span><span className="stat-value"><strong>{totalDrivers}</strong> 명</span></div>
                                <div className="stat-row"><span className="stat-label">운행 승인 사용자</span><span className="stat-value"><strong>207</strong> 명</span></div>
                                <div className="stat-row"><span className="stat-label">미배정 사용자</span><span className="stat-value"><strong>{unassignedDrivers}</strong> 명</span></div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Column 2: 관제 */}
                <div className="home-col">
                    <div className="home-section-tag">관제</div>
                    <div className="home-card-stack">
                        <div className="home-card">
                            <div className="home-card-header">
                                <div className="home-card-title">
                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"></polygon></svg>
                                    <span>EV 배터리 관제</span>
                                </div>
                                <button className="home-btn-outline mint" onClick={() => navigate('/control')}>관제 화면</button>
                            </div>
                            <div className="home-card-content">
                                <div className="stat-row"><span className="stat-label">실시간 모니터링</span><span className="stat-value"><strong>214</strong> 대</span></div>
                                <div className="stat-row"><span className="stat-label">주의 구간 진입</span><span className="stat-value"><strong>5</strong> 대</span></div>
                                <div className="stat-row"><span className="stat-label">교체 권고 차량</span><span className="stat-value"><strong>1</strong> 대</span></div>
                            </div>
                        </div>
                        <div className="home-card">
                            <div className="home-card-header">
                                <div className="home-card-title">
                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polygon points="3 11 22 2 13 21 11 13 3 11"></polygon></svg>
                                    <span>실시간 운행 관제</span>
                                </div>
                                <button className="home-btn-outline mint" onClick={() => navigate('/control')}>운행일지</button>
                            </div>
                            <div className="home-card-content">
                                <div className="stat-row"><span className="stat-label">금일 유효 주행</span><span className="stat-value"><strong>214</strong> 건</span></div>
                                <div className="stat-row"><span className="stat-label">고장 예측 알람</span><span className="stat-value"><strong>0</strong> 건</span></div>
                                <div className="stat-row"><span className="stat-label">누적 탄소 저감</span><span className="stat-value"><strong>17.4</strong> tCO₂eq</span></div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Column 3: 운영 */}
                <div className="home-col">
                    <div className="home-section-tag">운영</div>
                    <div className="home-card-stack">
                        <div className="home-card">
                            <div className="home-card-header">
                                <div className="home-card-title">
                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"></path></svg>
                                    <span>차량 정비 이력</span>
                                </div>
                                <button className="home-btn-outline mint" onClick={() => navigate('/repair')}>정비 화면</button>
                            </div>
                            <div className="home-card-content">
                                <div className="stat-row"><span className="stat-label">당월 정비 입고</span><span className="stat-value"><strong>3</strong> 건</span></div>
                                <div className="stat-row"><span className="stat-label">소모품 교체 및 수리</span><span className="stat-value"><strong>2</strong> 건</span></div>
                                <div className="stat-row"><span className="stat-label">진행 중 작업</span><span className="stat-value"><strong>1</strong> 건</span></div>
                            </div>
                        </div>
                        <div className="home-card coming-soon-overlay">
                            <div className="cs-ribbon">COMING SOON</div>
                            <div className="home-card-header disabled-text">
                                <div className="home-card-title"><span>배터리 재제조 이력</span></div>
                            </div>
                            <div className="home-card-content disabled-text">
                                <div className="stat-row"><span className="stat-label">재제조 의뢰건</span><span className="stat-value">- 건</span></div>
                                <div className="stat-row"><span className="stat-label">평균 성능 복원율</span><span className="stat-value">- %</span></div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Column 4: 기타 */}
                <div className="home-col">
                    <div className="home-section-tag">기타</div>
                    <div className="home-card-stack">
                        <div className="home-card">
                            <div className="home-card-header">
                                <div className="home-card-title">
                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="1" y="4" width="22" height="16" rx="2" ry="2"></rect><line x1="1" y1="10" x2="23" y2="10"></line></svg>
                                    <span>요금제 및 구독</span>
                                </div>
                                <button className="home-btn-outline mint" onClick={onShowPricing}>요금제 확인</button>
                            </div>
                            <div className="home-card-content">
                                <div className="stat-row"><span className="stat-label">활성 이용 플랜</span><span className="stat-value"><strong>프리미엄</strong></span></div>
                                <div className="stat-row"><span className="stat-label">자동 결제 예정</span><span className="stat-value"><strong>2026.05.07</strong></span></div>
                            </div>
                        </div>
                        <div className="home-card coming-soon-overlay">
                            <div className="cs-ribbon">COMING SOON</div>
                            <div className="home-card-header disabled-text">
                                <div className="home-card-title"><span>종합 맞춤형 분석</span></div>
                            </div>
                            <div className="home-card-content disabled-text">
                                <div className="stat-row"><span className="stat-label">월간 운영 리포트</span><span className="stat-value">- 건</span></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <footer className="home-footer">
                <button className="footer-link" onClick={() => setIsPrivacyOpen(true)}>개인정보 처리방침</button>
                <button className="footer-link" onClick={() => setIsTermsOpen(true)}>이용약관</button>
                <span className="copyright">© 2025 Prediction. All rights reserved.</span>
            </footer>

            {/* Privacy Policy Modal */}
            {isPrivacyOpen && (
                <div className="privacy-modal-overlay" onClick={() => setIsPrivacyOpen(false)}>
                    <div className="privacy-modal-card" onClick={e => e.stopPropagation()}>
                        <div className="privacy-modal-header">
                            <h2>개인정보 처리방침</h2>
                            <button className="btn-close-modal" onClick={() => setIsPrivacyOpen(false)}>
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
                            </button>
                        </div>
                        <div className="privacy-modal-body">
                            <div className="privacy-section">
                                <h3>1. 개인정보의 처리 목적</h3>
                                <p>주식회사 Prediction(이하 '회사')은 AI 기반 배터리 진단 및 플릿 관리 서비스 'EView' 제공을 위해 다음의 목적으로 개인정보를 처리합니다. 처리하고 있는 개인정보는 목적 이외의 용도로는 이용되지 않으며, 이용 목적이 변경되는 경우에는 별도의 동의를 받는 등 필요한 조치를 이행할 예정입니다.</p>
                                <p>• <b>서비스 제공 및 관리</b>: 차량용 배터리 상태 예측 AI 모델 고도화, 실시간 배터리 모니터링(SOH 분석), 차량 및 운전자 등록 관리, 디지털 운행일지 생성.</p>
                                <p>• <b>현장 안전 및 관제</b>: 법인 차량의 안전 운행 여부 확인, 이상 탐지 알림 발송, 사고 예방 피드백 제공.</p>
                            </div>

                            <div className="privacy-section">
                                <h3>2. 처리하는 개인정보의 항목</h3>
                                <p>회사는 서비스 제공을 위해 필요한 최소한의 정보를 수집하고 있습니다.</p>
                                <table className="privacy-table">
                                    <thead>
                                        <tr><th>구분</th><th>수집 항목</th></tr>
                                    </thead>
                                    <tbody>
                                        <tr><td>기본 회원정보</td><td>이름, 이메일 주소, 소속 기관(법인), 직위, 연락처</td></tr>
                                        <tr><td>차량 및 센서 데이터</td><td>차대번호(VIN), 차량번호, OBD 기반 배터리 원시 데이터(전압, 전류, 온도, 충/방전 패턴), 가속도 센서 데이터</td></tr>
                                        <tr><td>운행 정보</td><td>실시간 위치 정보(GPS), 주행 거리, 주행 속도, 급가감속 등 운행 패턴 데이터</td></tr>
                                    </tbody>
                                </table>
                            </div>

                            <div className="privacy-section">
                                <h3>3. 개인정보의 처리 및 보유 기간</h3>
                                <p>회사는 법령에 따른 개인정보 보유·이용기간 내에서 개인정보를 처리·보유합니다.</p>
                                <p>• <b>서비스 이용 계약 해지 시까지</b>: 단, 관련 법령에 의해 보존이 필요한 경우 해당 기간까지 보관합니다.</p>
                            </div>

                            <div className="privacy-section">
                                <h3>4. 개인정보의 제3자 제공</h3>
                                <p>회사는 정보주체의 동의가 있거나 관련 법령의 규정에 의한 경우를 제외하고는 개인정보를 제3자에게 제공하지 않습니다.</p>
                            </div>

                            <div className="privacy-section">
                                <h3>5. 이용자의 권리와 행사방법</h3>
                                <p>이용자는 언제든지 등록되어 있는 자신의 개인정보를 조회하거나 수정할 수 있으며 가입해지(동의철회)를 요청할 수도 있습니다.</p>
                            </div>
                        </div>
                        <div className="privacy-modal-footer">
                            <button className="btn-confirm-privacy" onClick={() => setIsPrivacyOpen(false)}>확인했습니다</button>
                        </div>
                    </div>
                </div>
            )}

            {/* Terms of Service Modal */}
            {isTermsOpen && (
                <div className="privacy-modal-overlay" onClick={() => setIsTermsOpen(false)}>
                    <div className="privacy-modal-card" onClick={e => e.stopPropagation()}>
                        <div className="privacy-modal-header">
                            <h2>이용약관</h2>
                            <button className="btn-close-modal" onClick={() => setIsTermsOpen(false)}>
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
                            </button>
                        </div>
                        <div className="privacy-modal-body">
                            <div className="privacy-section">
                                <h3>제 1 조 (목적)</h3>
                                <p>본 약관은 주식회사 Prediction(이하 '회사')이 제공하는 AI 기반 배터리 진단 및 플릿 관리 서비스 'EView'(이하 '서비스')의 이용 조건 및 절차, 회사와 이용자의 권리, 의무 및 책임 사항을 규정함을 목적으로 합니다.</p>
                            </div>

                            <div className="privacy-section">
                                <h3>제 2 조 (용어의 정의)</h3>
                                <p>1. '서비스'라 함은 회사가 제공하는 배터리 상태 예측 AI 분석, 모바일/웹 관제 대시보드 및 관련 통계 리포트 기능을 포함한 통합 관리 시스템을 의미합니다.</p>
                                <p>2. '이용자'라 함은 본 약관에 동의하고 회사가 승인한 법인 또는 개인 사업자를 의미합니다.</p>
                            </div>

                            <div className="privacy-section">
                                <h3>제 3 조 (서비스의 제공 및 변경)</h3>
                                <p>1. 회사는 이용자에게 다음과 같은 서비스를 제공합니다:</p>
                                <p>• 실시간 EV 배터리 SOH(State of Health) 모니터링 및 예측 알림.</p>
                                <p>• 디지털 운행 기록계 및 탄소 절감 리포트 생성.</p>
                                <p>• 플릿 관리 최적화 알고리즘 기반 데이터 분석 서비스.</p>
                                <p>2. 서비스의 내용이 변경되는 경우, 회사는 사전에 공지사항을 통해 이용자에게 알립니다.</p>
                            </div>

                            <div className="privacy-section">
                                <h3>제 4 조 (이용자의 의무)</h3>
                                <p>1. 이용자는 서비스를 이용할 때 관계 법령, 본 약관의 규정 및 서비스 이용 안내를 준수해야 합니다.</p>
                                <p>2. 이용자는 부착된 데이터 수집 장치(OBD 등)를 임의로 조작하거나 파손해서는 안 되며, 정상적인 데이터 전송이 이루어질 수 있도록 협조해야 합니다.</p>
                            </div>

                            <div className="privacy-section">
                                <h3>제 5 조 (책임의 한계)</h3>
                                <p>1. 회사의 AI 진단 결과는 데이터 기반의 예측치로, 실제 하드웨어의 결함을 100% 보장하지는 않습니다. 최종적인 차량 정비 및 안전 운행 결정의 책임은 이용자에게 있습니다.</p>
                                <p>2. 회사는 천재지변 또는 통신사의 장애 등 회사의 통제 범위를 벗어난 사유로 인한 서비스 중단에 대해서는 책임을 지지 않습니다.</p>
                            </div>
                        </div>
                        <div className="privacy-modal-footer">
                            <button className="btn-confirm-privacy" onClick={() => setIsTermsOpen(false)}>확인했습니다</button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

export default HomeView;
